import React, { useMemo } from 'react';

import { IntegrationsSettings } from '@shipstation/connections-ui';
import { DirectIntegrationsSettings } from '@shipstation/connections-ui/direct';
import { noop } from 'ui-components/default-props/noop';
import { emptyArray } from 'ui-components/default-props/empty';

import { useEnableDirectCuiIntegrations } from '../feature-flags/hooks/use-enable-direct-cui-integrations';
import { useCommonCuiProps } from './helpers/use-common-cui-props';
import { useCuiApiConfig } from './helpers/use-cui-api-config';
import { useCuiContextProps } from './helpers/use-cui-context-props';
import styles from './integrations-container.module.less';

type Props = {
  integrationAppId: number;
  onDelete?: () => void;
  sellerStores?: readonly unknown[];
};

export const CuiIntegrationsSettings = ({ integrationAppId, onDelete = noop, sellerStores = emptyArray }: Props) => {
  const isDirectMode = useEnableDirectCuiIntegrations();
  const commonCuiProps = useCommonCuiProps();
  const cuiApiConfig = useCuiApiConfig();
  const cuiContextProps = useCuiContextProps();

  const directContextProps = useMemo(() => ({ ...cuiContextProps, onDelete, sellerStores }), [cuiContextProps, onDelete, sellerStores]);

  if (isDirectMode) {
    return (
      <div className={styles.containerDirect}>
        <DirectIntegrationsSettings apiConfig={cuiApiConfig} contextProps={directContextProps} integrationAppId={integrationAppId} />
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <IntegrationsSettings {...commonCuiProps} integrationAppId={integrationAppId} onDelete={onDelete} sellerStores={sellerStores} />
    </div>
  );
};
